import types from './types';

const INITIAL_STATE = {
  isFetching: false,
  isDeleting: false,

  result: [],
};

const eligibilityNoteDocsReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

    case types.GET_NOTE_DOCS_REQUEST:
      return {
        ...state,
        result: [],
        isFetching: true,
      };

    case types.GET_NOTE_DOCS_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetching: false,
      };

    case types.GET_NOTE_DOCS_FAILURE:
      return {
        ...state,
        result: [],
        isFetching: false,
      };

    case types.DELETE_NOTE_DOC_REQUEST:
      return {
        ...state,
        result: [],
        isDeleting: true,
      };

    case types.DELETE_NOTE_DOC_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isDeleting: false,
      };

    case types.DELETE_NOTE_DOC_FAILURE:
      return {
        ...state,
        result: [],
        isDeleting: false,
      };

    default:
      return state;
  }
};

export default eligibilityNoteDocsReducer;
